var TipoRequerimento = /** @class */ (function () {
    function TipoRequerimento() {
    }
    return TipoRequerimento;
}());
export { TipoRequerimento };
